<template>
  <div class="application-details-display">
    <div class="toolbar text-right">
      <span class="badge badge-danger"
        v-if="application.applicationFlagged">
        <span class="fa fa-flag"></span> Flagged
      </span>
      <router-link :to="`/membership/applications/edit/${application.uuid}`" class="btn btn-primary">
        <span class="fa fa-pencil-alt fa-fw"></span> Edit Application
      </router-link>
      <dropdown-input
        label="Actions"
        label-icon="fa-check-circle"
        :dropright="true"
        :actions="applicationActions(application, loggedInUser)"
        @action="executeAction($event, application)">
      </dropdown-input>
    </div>
    <div class="row">
      <div class="col-md-7">
        <nav-tab :tab-count="4" ref="tabs">
          <!-- Account Details -->
          <div title="Applicant Details" slot="tab1" :icon="personalStatus">
            <table class="table table-bordered table-striped table-hover table-sm">
              <thead class="thead-light">
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                  <th width="10%">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-fw fa-user"></span> Account Details
                  </td>
                </tr>
                <tr>
                  <td><strong>Username</strong></td>
                  <td>{{ application.username }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.username,
                      'fa-check text-success': application.username
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Email</strong></td>
                  <td>
                    <a :href="`mailto:${application.email}`">
                      {{ application.email }}
                    </a>
                  </td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.email,
                      'fa-check text-success': application.email
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Registered Date</strong></td>
                  <td>{{ application.registeredDate | date_format }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.registeredDate,
                      'fa-check text-success': application.registeredDate
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-fw fa-id-card"></span> Personal Details
                  </td>
                </tr>
                <tr>
                  <td><strong>Full Name</strong></td>
                  <td>{{ application.fullName }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.fullName,
                      'fa-check text-success': application.fullName
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Date of Birth</strong></td>
                  <td>{{ application.dateOfBirth | short_date_format }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.dateOfBirth,
                      'fa-check text-success': application.dateOfBirth
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Gender</strong></td>
                  <td>{{ application.gender }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.gender,
                      'fa-check text-success': application.gender
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Address</strong></td>
                  <td>{{ application.address }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.address,
                      'fa-check text-success': application.address
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Suburb</strong></td>
                  <td>{{ application.suburb }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.suburb,
                      'fa-check text-success': application.suburb
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Postcode</strong></td>
                  <td>{{ application.postcode }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.postcode,
                      'fa-check text-success': application.postcode
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>State</strong></td>
                  <td>{{ application.state }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.state,
                      'fa-check text-success': application.state
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Home Phone</strong></td>
                  <td>
                    <a :href="`tel:${application.homePhone}`">
                        {{ application.homePhone }}
                    </a>
                  </td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.homePhone,
                      'fa-check text-success': application.homePhone
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Mobile Phone</strong></td>
                  <td>
                    <a :href="`tel:${application.mobilePhone}`">
                        {{ application.mobilePhone }}
                    </a>
                  </td>
                  <td>
                    <span class="fa fa-check text-success"></span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Work Phone</strong></td>
                  <td>
                    <a :href="`tel:${application.workPhone}`">
                        {{ application.workPhone }}
                    </a>
                  </td>
                  <td>
                    <span class="fa fa-check text-success"></span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-ambulance"></span> Emergency Contact
                  </td>
                </tr>
                <tr>
                  <td><strong>Full Name</strong></td>
                  <td>{{ application.emergencyFullName }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.emergencyFullName,
                      'fa-check text-success': application.emergencyFullName
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Relation</strong></td>
                  <td>{{ application.emergencyRelation }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.emergencyRelation,
                      'fa-check text-success': application.emergencyRelation
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Phone</strong></td>
                  <td>
                    <a :href="`tel:${application.emergencyPhone}`">
                      {{ application.emergencyPhone }}
                    </a>
                  </td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.emergencyPhone,
                      'fa-check text-success': application.emergencyPhone
                    }">
                    </span>
                  </td>
                </tr>
                <template v-if="application.AccountType.name === 'Business'">
                  <tr>
                    <td colspan="3" class="bg-primary text-white">
                      <span class="fa fa-briefcase"></span>
                      Business Details
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Name</strong></td>
                    <td>{{ application.businessName }}</td>
                    <td>
                      <span class="fa" :class="{
                        'fa-times text-danger': !application.businessName,
                        'fa-check text-success': application.businessName
                      }">
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>ABN</strong></td>
                    <td>{{ application.businessAbn }}</td>
                    <td>
                      <span class="fa" :class="{
                        'fa-times text-danger': !application.businessAbn,
                        'fa-check text-success': application.businessAbn
                      }">
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Address</strong></td>
                    <td>{{ application.businessAddress }}</td>
                    <td>
                      <span class="fa" :class="{
                        'fa-times text-danger': !application.businessAddress,
                        'fa-check text-success': application.businessAddress
                      }">
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Number of Employees</strong></td>
                    <td>{{ application.businessEmployees }}</td>
                    <td>
                      <span class="fa fa-check text-success"></span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <!-- Supporting Documents -->
          <div title="Supporting Documents" slot="tab2" :icon="documentStatus">
            <table class="table table-bordered table-striped table-hover table-sm">
              <thead class="thead-light">
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                  <th width="10%">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-fw fa-home"></span>
                    Proof of Address
                  </td>
                </tr>
                <tr>
                  <td><strong>Listed Address</strong></td>
                  <td>{{ application.address }}<br>
                  {{ application.suburb }} {{ application.postcode }}, {{ application.state }}</td>
                  <td><em>N/A</em></td>
                </tr>
                <tr>
                  <td><strong>Proof of Address</strong></td>
                  <td>
                    <a v-if="application.ProofOfAddress"
                      class="btn btn-xs btn-primary"
                      :href="url + application.ProofOfAddress.objectKey"
                      target="_blank">
                      <span class="fa fa-fw fa-download"></span>
                      Download
                    </a>
                  </td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.ProofOfAddress,
                      'fa-check text-success': application.ProofOfAddress
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-fw fa-address-card"></span>
                    Driver's License
                  </td>
                </tr>
                <tr>
                  <td><strong>License Number</strong></td>
                  <td>{{ application.driversLicense }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.driversLicense,
                      'fa-check text-success': application.driversLicense
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>State Issued</strong></td>
                  <td>{{ application.driversLicenseIssued }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.driversLicenseIssued,
                      'fa-check text-success': application.driversLicenseIssued
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>International License</strong></td>
                  <td>{{ application.driversLicenseCountry }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.driversLicenseCountry && (!application.driversLicenseIssued || application.driversLicenseIssued === 'INT'),
                      'fa-check text-success': application.driversLicenseCountry || application.driversLicenseIssued !== 'INT'
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Drivers License (Front)</strong></td>
                  <td>
                    <a v-if="application.DriversLicense"
                      class="btn btn-xs btn-primary"
                      :href="url + application.DriversLicense.objectKey"
                      target="_blank">
                        <span class="fa fa-fw fa-download"></span>
                        Download
                      </a>
                  </td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.DriversLicense,
                      'fa-check text-success': application.DriversLicense
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Drivers License (Back)</strong></td>
                  <td>
                    <a v-if="application.DriversLicenseBack"
                    class="btn btn-xs btn-primary"
                    :href="url + application.DriversLicenseBack.objectKey"
                    target="_blank">
                      <span class="fa fa-fw fa-download"></span>
                      Download
                    </a>
                  </td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.DriversLicenseBack,
                      'fa-check text-success': application.DriversLicenseBack
                    }">
                    </span>
                  </td>
                </tr>
                <template v-if="application.AccountType.name === 'Student'">
                  <tr>
                    <td colspan="3" class="bg-primary text-white">
                      <span class="fa fa-fw fa-graduation-cap"></span>
                      Student Details
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Proof of Enrolment</strong></td>
                    <td>
                        <a v-if="application.ProofOfEnrolment"
                        class="btn btn-xs btn-primary"
                        :href="url + application.ProofOfEnrolment.objectKey"
                        target="_blank">
                          <span class="fa fa-download fa-fw"></span>
                          Download
                        </a>
                    </td>
                    <td>
                      <span class="fa" :class="{
                        'fa-times text-danger': !application.ProofOfEnrolment,
                        'fa-check text-success': application.ProofOfEnrolment
                      }">
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Student Expiry</strong></td>
                    <td>
                        {{ application.studentExpiry | short_date_format }}
                    </td>
                    <td>
                      <span class="fa" :class="{
                        'fa-times text-danger': !application.studentExpiry,
                        'fa-check text-success': application.studentExpiry
                      }">
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <!-- Driver History -->
          <div title="Driving History" slot="tab3" :icon="drivingStatus">
            <table class="table table-bordered table-striped table-hover table-sm">
              <thead class="thead-light">
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                  <th width="10%">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-fw fa-history"></span>
                    History
                  </td>
                </tr>
                <tr>
                  <td><strong>Years Driving</strong></td>
                  <td>{{ application.driversYears }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.driversYears,
                      'fa-check text-success': application.driversYears
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Infringements (past 3 yrs)</strong></td>
                  <td>{{ application.drivingInfringements }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-question-circle text-amber': application.drivingInfringements > 0,
                      'fa-check text-success': application.drivingInfringements === 0
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Accidents (past 3 yrs)</strong></td>
                  <td>{{ application.accidents }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-question-circle text-amber': application.accidents > 0,
                      'fa-check text-success': application.accidents === 0
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Alcohol Related Incidents (past 7 yrs)</strong></td>
                  <td>{{ application.alcoholRelated ? "Yes" : "No" }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-question-circle text-amber': application.alcoholRelated,
                      'fa-check text-success': !application.alcoholRelated
                    }">
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Membership -->
          <div title="Membership" slot="tab4" :icon="membershipStatus">
            <table class="table table-bordered table-striped table-hover table-sm">
              <thead class="thead-light">
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                  <th width="10%">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-fw fa-credit-card"></span>
                    Payment Method
                  </td>
                </tr>
                <tr>
                  <td><strong>Credit Card</strong></td>
                  <td>
                    <template v-if="application.CreditCards[0]">
                      <span class="fa-fw" :class="application.CreditCards[0].icon.replace('fa', 'fab')"></span> {{ application.CreditCards[0].dropdownLabel }}
                    </template>
                  </td>
                  <td>
                    <span class="fa" v-if="!application.MasterUuid" :class="{
                      'fa-times text-danger': !application.CreditCards.length,
                      'fa-check text-success': application.CreditCards.length
                    }">
                    </span>
                    <span v-if="application.MasterUuid" class="fa" :class="{
                      'fa-times text-danger': !application.Master.CreditCards.length,
                      'fa-check text-success': application.Master.CreditCards.length
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="bg-primary text-white">
                    <span class="fa fa-fw fa-tasks"></span>
                    Application Status
                  </td>
                </tr>
                <tr>
                  <td><strong>Account Type</strong></td>
                  <td>{{ application.AccountType.name }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.AccountType,
                      'fa-check text-success': application.AccountType
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Application Flagged</strong></td>
                  <td>{{ application.applicationFlagged ? 'Yes' : 'No' }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-question-circle text-amber': application.applicationFlagged,
                      'fa-check text-success': !application.applicationFlagged
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Application Checked</strong></td>
                  <td>{{ application.applicationReviewed ? 'Yes' : 'No' }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.applicationReviewed,
                      'fa-check text-success': application.applicationReviewed
                    }">
                    </span>
                  </td>
                </tr>
                <tr v-if="application.PromoCodes.length > 0">
                  <td><strong>Promo Code Applied:</strong></td>
                  <td>
                    {{ application.PromoCodes[0].code }} - {{ application.PromoCodes[0].description }}<br>
                    <em class="badge badge-pill badge-default">{{ parsePromoType(application.PromoCodes[0]) }}</em>
                  </td>
                  <td><span class="fa fa-check text-success"></span></td>
                </tr>
                <tr>
                  <td><strong>Membership Fee Charged</strong></td>
                  <td>{{ application.membershipLastPaid ? 'Yes' : 'No' }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.membershipLastPaid,
                      'fa-check text-success': application.membershipLastPaid
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Smart Card</strong></td>
                  <td>
                    <span class="badge badge-danger badge-margin"
                      v-if="!application.cardId">
                      <span class="fa fa-id-card"></span> No Smartcard Assigned
                    </span>
                    <span class="badge badge-success badge-margin"
                    v-if="application.cardId">
                      <span class="fa fa-id-card"></span>
                      {{ application.Smartcard.cardNumber }}
                    </span>
                  </td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.cardId,
                      'fa-check text-success': application.cardId
                    }">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Application Approved</strong></td>
                  <td>{{ application.applicationApproved ? 'Yes' : 'No' }}</td>
                  <td>
                    <span class="fa" :class="{
                      'fa-times text-danger': !application.applicationApproved,
                      'fa-check text-success': application.applicationApproved
                    }">
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </nav-tab>
      </div>
      <div class="col-md-5">
        <div class="card card-primary">
          <div class="card-header">
            <span class="fa fa-sticky-note"></span> Notes
          </div>
          <div class="list-group list-group-flush">
            <template v-for="(note, i) in application.AccountNotes">
              <div class="list-group-item" :key="i">
                <account-note-display :data="note"></account-note-display>
              </div>
            </template>
            <div class="list-group-item" v-if="application.AccountNotes.length === 0">
              No account notes
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountNoteDisplay from '@/components/displays/AccountNoteDisplay'
import DropdownInput from '@/components/inputs/DropdownInput'
import NavTab from '@/components/NavTab'
import { mapGetters, mapActions } from 'vuex'
import {
  ADD_SMARTCARD,
  EMAIL_APPLICATION,
  EDIT_APPLICATION,
  FILL_APPLICATION,
  CHECK_APPLICATION,
  MOVE_TO_APPLICATIONS,
  CHARGE_MEMBERSHIP,
  CHARGE_SETUP,
  CHARGE_DRIVER,
  UNASSIGN_SMARTCARD,
  EDIT_SMARTCARD,
  LOAD_APPLICATION,
  APPROVE_APPLICATION,
  FLAG_APPLICATION,
  BLACKLIST_MEMBER,
  DECLINE_APPLICATION,
  DELETE_APPLICATION,
  SEND_GUARANTOR_FORM,
  UPLOAD_GUARANTOR_FORM,
  ADD_ACCOUNT_NOTE,
  WAIVE_MEMBERSHIP,
  UNFLAG_APPLICATION
} from '@/vuex/types'

export default {
  name: 'ApplicationDetailsDisplay',
  components: {
    AccountNoteDisplay,
    DropdownInput,
    NavTab
  },
  computed: {
    age () {
      return moment().diff(moment(this.application.dateOfBirth), 'years')
    },
    application () {
      return {
        AccountType: {},
        DriversLicense: {},
        DriversLicenseBack: {},
        AccountNotes: [],
        PromoCodes: [],
        AmazonImages: [],
        Organization: {},
        ...this.loadedUser,
        ...this.updatedApplication
      }
    },
    personalStatus () {
      if (this.application.username && this.application.fullName &&
      this.application.dateOfBirth && this.application.gender &&
      this.application.email && this.application.registeredDate &&
      this.application.address && this.application.suburb &&
      this.application.postcode && this.application.state &&
      this.application.homePhone && this.application.emergencyFullName &&
      this.application.emergencyPhone && this.application.emergencyRelation) {
        return 'fa-check-square'
      } else {
        return 'fa-exclamation-circle nav-danger'
      }
    },
    documentStatus () {
      let studentFilled = this.application.AccountType.name !== 'Student'
      if (!studentFilled) {
        // student account check
        studentFilled = this.application.studentExpiry && this.application.ProofOfEnrolment
      }
      let internationalFilled = this.application.driversLicenseIssued !== 'INT'
      if (!internationalFilled) {
        internationalFilled = this.application.driversLicenseCountry !== ''
      }
      if (studentFilled && internationalFilled && this.application.driversLicense &&
       this.application.driversLicenseIssued && this.application.DriversLicenseBack && this.application.ProofOfAddress) {
        return 'fa-check-square'
      } else {
        return 'fa-exclamation-circle nav-danger'
      }
    },
    drivingStatus () {
      if (this.application.driversYears > 0 && this.application.drivingInfringements === 0 &&
      !this.application.alcoholRelated && this.application.accidents === 0) {
        return 'fa-check-square'
      } else {
        return 'fa-exclamation-circle nav-danger'
      }
    },
    membershipStatus () {
      if (this.application.AccountType && this.application.cardId) {
        return 'fa-check-square'
      } else {
        return 'fa-exclamation-circle nav-danger'
      }
    },
    ...mapGetters([
      'loadedUser',
      'loggedInUser',
      'applicationActions'
    ])
  },
  data () {
    return {
      updatedApplication: {},
      url: 'https://techcar-dev.s3.amazonaws.com/'
    }
  },
  watch: {
    async $route () {
      await this[LOAD_APPLICATION](this.$route.params.application_id)
      await this.$nextTick()
      this.$refs.tabs.refreshTabs()
    }
  },
  async mounted () {
    await this[LOAD_APPLICATION](this.$route.params.application_id)
    await this.$nextTick()
    this.$refs.tabs.refreshTabs()
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedApplication = result.updated
    },
    parsePromoType (promo) {
      switch (promo.type) {
        case 'waivedFee':
          return 'Waived Membership Fee'
        case 'waivedFeeCredits':
          return 'Waived Membership Fee + $' + promo.amount + ' credits'
      }
    },
    ...mapActions([
      ADD_SMARTCARD,
      LOAD_APPLICATION,
      EMAIL_APPLICATION,
      EDIT_APPLICATION,
      EDIT_SMARTCARD,
      FILL_APPLICATION,
      CHECK_APPLICATION,
      MOVE_TO_APPLICATIONS,
      CHARGE_MEMBERSHIP,
      CHARGE_SETUP,
      CHARGE_DRIVER,
      UNASSIGN_SMARTCARD,
      APPROVE_APPLICATION,
      FLAG_APPLICATION,
      DECLINE_APPLICATION,
      BLACKLIST_MEMBER,
      DELETE_APPLICATION,
      SEND_GUARANTOR_FORM,
      UPLOAD_GUARANTOR_FORM,
      ADD_ACCOUNT_NOTE,
      WAIVE_MEMBERSHIP,
      UNFLAG_APPLICATION
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/ApplicationDetailsDisplay.vue